import flowRight from 'lodash.flowright';
import { withGraphqlData } from './decorators/withGraphqlData';
import { withPageSetup } from './decorators/withPageSetup';
import { connect } from 'react-redux';

import './styles/inav.scss';
import './styles/common.scss';

export const pageWrapper = (WrappedPage, routeConfigs) => {
  const mapStateToProps = state => ({
    intlPage: state.intlPage
  });

  const mapDispatchToProps = dispatch => ({
    fetchData: props =>
      dispatch({
        type: 'FETCH_DATA',
        payload: props
      }),
    dispatch: dispatch
  });

  const decoratePage = flowRight([
    connect(
      mapStateToProps,
      mapDispatchToProps
    ),
    withGraphqlData(routeConfigs),
    withPageSetup(routeConfigs)
  ]);

  return decoratePage(WrappedPage);
};
